export type Regulator =
  | "APRA"
  | "RBNZ"
  | "Fed"
  | "PRA"
  | "EBA"
  | "OJK"
  | "FSA"
  | "CBIRC"
  | "MAS";

export const regulatorNameLongLookup: Record<Regulator, string> = {
  APRA: "Australian Prudential Regulation Authority",
  RBNZ: "Reserve Bank of New Zealand",
  Fed: "Board of Governors of the Federal Reserve System",
  PRA: "Prudential Regulatory Authority",
  EBA: "European Banking Authority",
  OJK: "The Financial Services Authority",
  FSA: "Financial Services Agency",
  CBIRC: "China Banking and Insurance Regulatory Commission",
  MAS: "Monetary Authority of Singapore",
};
